<template>
  <div class="step3 section is-mobile-wider" v-if="thankYouPage === false">
    <div class="container has-text-centered">
      <div class="columns">
        <div class="coloumn column is-8 is-offset-2">
          <article class="message is-danger" v-if="isProcessError">
            <div class="message-header">
              <p>
                <span class="icon">
                  <i class="mdi mdi-alert-circle mdi-12px"></i>
                </span>
                Oh Noo! Der Kauf konnte nicht vollständig durchgeführt
                werden!
              </p>
            </div>
            <div class="message-body">
              <p></p>Das sollte nicht passieren und tut uns leid! Aber wir bekommen das
              gemeinsam hin. Bitte kopiere den folgenden Text und sende ihn uns
              über das <router-link to="kontakt">Kontaktformular</router-link>:</p><p><strong
                >{{ ProcessError }}</strong
              ></p>
            </div>
          </article>

          <ValidationObserver ref="observer" v-slot="{ passes }">
            <h3 class="subtitle is-4 is-size-5-mobile">
              Wie möchtest du bezahlen?
            </h3>
            <div class="field">
              <b-radio
                v-model="radio"
                size="is-large"
                type="is-info"
                native-value="Kreditkarte"
                >Kreditkarte</b-radio
              >
              <b-radio
                v-model="radio"
                size="is-large"
                type="is-info"
                native-value="PayPal"
                >PayPal</b-radio
              >
            </div>
            <div class="content" v-if="radio !== 'Kreditkarte'">
              <!--Du wirst automatisch zu PayPal weitergeleitet, um den Kauf
              abzuschließen.-->

              <PayPal
              currency="EUR"
              locale="de_DE"
              :amount="total.toString()"
              :description="ppdescription"
              :client="ppcredentials"
              :experience="ppexperience"
              :button-style="ppstyle"
              :commit="false"
              v-on:payment-authorized="paymentAuthorized"
              v-on:payment-completed="paymentCompleted"
              v-on:payment-cancelled="paymentCancelled"
              env="production">
            </PayPal>
            <p class="has-text-info" v-if="pperror">
                Bitte autorisiere die Zahlung erst bei PayPal!
              </p>

            </div>
            <div class="content" v-else="radio !== 'Kreditkarte'">
              <div id="card-element">
              </div>
              <p class="has-text-info" v-if="!complete && ccerror">
                Die Kreditkartendaten sind nicht vollständig ausgefüllt.
              </p>
            </div>

            <article class="message is-danger" v-if="isPaymentError">
              <div class="message-header">
                <p>
                  <span class="icon">
                    <i class="mdi mdi-alert-circle mdi-12px"></i>
                  </span>
                  Die Zahlung konnte nicht durchgeführt werden.
                </p>
              </div>
              <div class="message-body">
                Bitte probiere ein anderes Zahlungsmittel aus oder kontrolliere
                noch einmal die eingegebenen Daten.
              </div>
            </article>

            <div class="field">
              <ValidationProvider
                :rules="{ required: { allowFalse: false } }"
                name="Terms"
                v-slot="{ errors }"
              >
              <div class="columns is-mobile has-text-left is-size-6 is-size-7-mobile">
                <div class="column is-2-mobile is-1-tablet">
                <b-checkbox
                  size="is-large"
                  native-value="AGB"
                  v-model="Terms"
                  type="is-info"
                >
                </b-checkbox>
                </div>
                <div class="column is-10-mobile is-11-tablet">Hiermit akzeptiere ich die <a @click="agbModalActive = true">AGB</a> und habe mein  <a @click="widerrufModalActive = true">Widerrufsrecht</a> zur Kenntnis genommen.
                  </div>
              </div>
              <p class="has-text-info">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
             <b-modal :active.sync="agbModalActive" :width="720" scroll="keep">
              <div class="card modalpadding">
                <Agbtext />
              </div>
            </b-modal>
            <b-modal :active.sync="widerrufModalActive" :width="720" scroll="keep">
              <div class="card modalpadding">
                <Wiederrufstext />
              </div>
            </b-modal>
            <h3
              class="subtitle is-5 is-size-6-mobile spacetop has-text-weight-bold"
            >
              Du erwirbst folgendes Produkt:
            </h3>
            <div class="container">
              <div class="columns is-multiline">
                <div class="coloumn column is-7 is-12-mobile is-7-tablet is-8-desktop is-9-widescreen is-9-fullhd has-text-left">
                  <p class="is-size-6 is-size-7-mobile">
                    {{ squaremeterbringer }} Gläser Sommertrachthonig mit je 250 Gramm Inhalt aus der Blühsaison 2021 inkl. Versand (100 Gramm Honig kosten 3€, Lieferung innerhalb einer Woche)
                  </p>
                </div>
                <div class="coloumn column is-12-mobile is-5-tablet is-4-desktop is-3-widescreen is-3-fullhd is-vbottom has-text-right">
                  <p class="is-size-6 is-size-7-mobile">
                    <span class="is-pulled-left">Preis:</span>
                    <span class="is-pulled-right priceborder">{{
                      pricebringer | currency
                    }}</span>
                  </p>
                </div>
                <div
                  class="coloumn column is-12-mobile is-5-tablet is-4-desktop is-3-widescreen is-3-fullhd is-offset-0-mobile is-offset-7-tablet is-offset-8-desktop is-offset-9-widescreen is-offset-9-fullhed has-text-right topspacer"
                >
                  <p class="is-size-6 is-size-7-mobile is-clearfix">
                    <!--<span class="is-pulled-left">Netto</span>
                    <span class="is-pulled-right">
                      {{ pricenet | currency }}
                    </span>
                    <br />
                    <span class="is-pulled-left">19% Mwst.</span>
                    <span class="is-pulled-right">{{ vat | currency }}</span>
                    <br />-->
                    <span class="is-pulled-left has-text-weight-bold"
                      >Gesamt</span
                    >
                    <span
                      class="is-pulled-right has-text-weight-bold totalborder"
                      >{{ total | currency }}</span
                    ><br>
                  </p>
                </div>
              </div>
              <p class="is-size-6 is-size-7-mobile has-text-centered">Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.</p>
            </div>

            <b-button
              type="is-primary"
              size="is-large"
              class="is-pulled-right spacetop"
              @click="passes(pay)"
              >jetzt kaufen</b-button
            >
            <b-button
              type="is-info"
              size="is-large"
              class="is-pulled-left is-outlined has-text-weight-normal spacetop"
              @click="backwardstep"
              >zu Schritt 2</b-button
            >

            <b-loading
              :is-full-page="true"
              :active.sync="isLoading"
            ></b-loading>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Agbtext from "@/components/legal/Agbtext.vue";
import Wiederrufstext from "@/components/legal/Wiederrufstext.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "vee-validate/dist/rules";
//import { Card, createToken } from "vue-stripe-elements-plus";
//import { StripeElement, Stripe } from "vue-stripe-better-elements";
import PayPal from 'vue-paypal-checkout';
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "Step3",
  data() {
    return {
      radio: "Kreditkarte",
      ccerror: false,
      pperror: false,
      ppready: false,
      paypalauth: "",
      Terms: "",
      isLoading: false,
      isPaymentError: false,
      isProcessError: false,
      ProcessError: "Es ist ein allgemeiner Serverfehler aufgetreten am "+Date(),
      thankYouPage: false,
      loading: false,
      complete: false,
      widerrufModalActive: false,
      agbModalActive: false,
      rechnungsnummer: "",
      ppcredentials: { // env in component is pulling correct key
        sandbox: 'AWf_TA5Co2TyTH7mpewnlp5gQMivhF9P5fkQBG7Cf2I6IItC6mqY0wfpwFGoDEwAfkNlE_viup4VojSh',
        production: 'AXTfA62hGr73_BOeKNkbVdk5EunG4Xx6dZV242UUp618jfOgdesIcyEuvMWFk8BUWgBcpF6SlzonyGlX'
      },
      ppstyle: {
          label: 'paypal',
          size:  'responsive',
          shape: 'rect',
          color: 'blue',
          tagline: 'false',
          branding: 'true'
      },
      ppexperience: {
        input_fields: {
          no_shipping: 1
        }
      },
      ppdescription: "Blühpatenschaft Wilde Pracht",
      stripeEmail: "",
      stripeKey: "pk_live_yVWxrtKhxtWLbE6Q3GNiWT3k003XfpsnKq",
      //pk_live_yVWxrtKhxtWLbE6Q3GNiWT3k003XfpsnKq
      //pk_test_ht1ZwYWEjzubjwBEfGZEnSwd00f1QrHX88
      //stripeKey: process.env.STRIPE_CLIENT_KEY,
      stripe: '',
      elements: '',
      card: '',
      elsOptions: {
        locale: "de",
        fonts: [
          {
            //cssSrc: 'https://fonts.googleapis.com/css2?family=Alegreya+Sans:wght@400'
            src: 'url(https://wilde-pracht.de/email/AlegreyaSans-Regular.woff)',
            family: 'Alegreya Sans',
          }
        ]
      },
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
        hidePostalCode: true,
        style: {
          base: {
            color: '#363636',
            fontSmoothing: 'antialiased',
            fontSize: '24px',
            fontWeight: 400,
            fontFamily: 'Alegreya Sans'
          }
        }
      }
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    //StripeElement,
    PayPal,
    Agbtext,
    Wiederrufstext
  },
  props: {
    pricebringer: [String, Number],
    squaremeterbringer: Number,
    giftquestionbringer: String,
    giftnamebringer: String,
    buyerfirstbringer: String,
    buyerlastbringer: String,
    StreetNumberbringer: String,
    adressline2bringer: String,
    zipbringer: String,
    placebringer: String,
    countrybringer: String,
    buyerfirstbringerdelivery: String,
    buyerlastbringerdelivery: String,
    StreetNumberbringerdelivery: String,
    adressline2bringerdelivery: String,
    zipbringerdelivery: String,
    placebringerdelivery: String,
    countrybringerdelivery: String,
    emailbringer: String,
  },
  computed: {
    pricenet: function() {
      return this.pricebringer / 1.07;
    },
    vat: function() {
      return this.pricebringer - this.pricenet;
    },
    total: function() {
      return this.pricenet + this.vat;
    },
    today: function() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      return dd + "." + mm + "." + yyyy;
    },
  },
  mounted() {
    this.configureStripe();
  },
  methods: {
    backwardstep() {
      this.$emit("activeStep", 1);
      this.$matomo.trackEvent("Honeyprocess", "Step3", "go back to Step2");
    },

    paymentAuthorized: function (data) {
      //console.log("Authorized: "+JSON.stringify(data));
      this.ppready = true;
      this.isPaymentError = false;
      this.paypalauth = JSON.stringify(data);
      this.paypalauth = data;
    },

    paymentCompleted: function (data) {;
      //console.log("Completed: "+JSON.stringify(data));
    },

    paymentCancelled: function (data) {
      this.pperror = false
      this.isPaymentError = true;
      //console.log("Cancelled: "+JSON.stringify(data));
    },

    configureStripe(){
        this.stripe = Stripe( this.stripeKey );

        this.elements = this.stripe.elements(this.elsOptions);
        this.card = this.elements.create('card', this.stripeOptions);

        this.card.mount('#card-element');

        //check if cc values are complete
        this.card.on('change', (event) => {
          if (event.complete) {
            this.complete = true;
          }
          else {
            this.complete = false;
          }
        });
    },

    pay() {
      // create JSON with all Purchase Data
      var isGift;
      if (this.giftquestionbringer !== "selbst ") {
        isGift = true;
      } else {
        isGift = false;
      }
      const paydata = {
        OrderHashHoney: uuidv4(),
        Customer: {
          Email: this.emailbringer,
          Firstname: this.buyerfirstbringer,
          Lastname: this.buyerlastbringer,
        },
        Deliveryadress: {
          isdelivery: isGift,
          Firstnamedelivery: this.buyerfirstbringerdelivery,
          Lastnamedelivery: this.buyerlastbringerdelivery,
          Adress1delivery: this.StreetNumberbringerdelivery,
          Adress2delivery: this.adressline2bringerdelivery,
          Zipcodedelivery: this.zipbringerdelivery,
          Placedelivery: this.placebringerdelivery,
          Countrydelivery: this.countrybringerdelivery,
        },
        Adress: {
          Adress1: this.StreetNumberbringer,
          Adress2: this.adressline2bringer,
          Zipcode: this.zipbringer,
          Place: this.placebringer,
          Country: this.countrybringer,
        },
        Purchase: {
          Area: this.squaremeterbringer,
          PriceNet: this.pricenet.toFixed(2).replace(/\./g, ","),
          PriceVat: this.vat.toFixed(2).replace(/\./g, ","),
          PriceTotal: this.total.toFixed(2).replace(/\./g, ","),
          PriceStripe: Math.floor(this.total * 100),
        },
        Payment: {
          Methode: this.radio,
          InvoiceDate: this.today,
        },
        Product: {
		      OrderedProduct: "Wilde Pracht Honig",
		      OrderQuantity: this.squaremeterbringer,
		      Saison: 2021
        }
      };

      // check payment method to perform payment process
      if (this.radio === "Kreditkarte") {
        if (this.complete === true) {
          this.paystripe(paydata);
        } else {
          this.ccerror = true;
          //console.log("CC not finished!");
        }
      } else if (this.radio === "PayPal") {
        if (this.ppready === true) {
          paydata.Purchase.AuthorizationPayPal = this.paypalauth;
          this.paypaypal(paydata);
        } else {
          this.pperror = true;
          //console.log("PayPal not finished!");
        }
      }
      this.$matomo.trackEvent(
        "Honeyprocess",
        "Step3",
        "Purchase via: " + this.radio
      );
    },

    async paystripe(stripedata) {
      this.isLoading = true;

      try {
        const res = await axios.post(".netlify/functions/honeystripe", stripedata, {
          headers: { "Content-Type": "application/json" },
        });
        if (res.status === 200) {
          // CC payment was successful
          var vm = this;
          this.stripe
            .confirmCardPayment(res.data.status.client_secret,{
              payment_method: {
                card: this.card,
                "billing_details": {
                  "address": {
                    "city": stripedata.Adress.Place,
                    "country": null,
                    "line1": stripedata.Adress.Adress1,
                    "line2": stripedata.Adress.Adress2,
                    "postal_code": stripedata.Adress.Zipcode,
                    "state": null
                  },
                  "email": stripedata.Customer.Email,
                  "name": stripedata.Customer.Firstname+" "+stripedata.Customer.Lastname,
                  "phone": null
                }
              }
            }).then(function(result) {
            if (result.error) {
              // Show error to your customer (e.g., insufficient funds)
              //console.log(result.error.message);
              vm.isLoading = false;
              vm.isPaymentError = true;
            } else {
              // The payment has been processed!
              if (result.paymentIntent.status === 'succeeded') {
                //console.log("Gee comes from geenius!");
                //console.log(result);
                //stripedata.Purchase.ResultStripe = result;
                //console.log("Saved it?");
                //console.log(stripedata);
                vm.invoicenr(stripedata);
              }
            }
          });
        } else {
          this.isLoading = false;
          this.isPaymentError = true;
          //console.log("Could not process Stripe Payment.");
        }
        //console.log(JSON.stringify(res, null, 2));
      } catch (error) {
        this.isLoading = false;
        this.isPaymentError = true;
        //console.log("------> ERROR:", error);
      }
    },

    async paypaypal(paypaldata) {
      this.isLoading = true;

      try {
        const res = await axios.post(".netlify/functions/honeypaypal", paypaldata, {
          headers: { "Content-Type": "application/json" },
        });
        if (res.status === 200) {
          // PayPal payment was successful
          // Add PayPal Data to JSON
          paypaldata.Purchase.ResultPayPal = res.data;
          //console.log("PayPalResult: "+JSON.stringify(res.data));
          this.invoicenr(paypaldata);
        } else {
          this.isLoading = false;
          this.isPaymentError = true;
          //console.log("Could not process PayPal Payment.");
        }
        //console.log(JSON.stringify(res, null, 2));
      } catch (error) {
        this.isLoading = false;
        this.isPaymentError = true;
        //console.log("------> ERROR:", error);
      }
    },

    async invoicenr(invoicedata) {
      try {
        const res = await axios.post("/.netlify/functions/honeyinvoice", {}, {
          headers: { "Content-Type": "application/json" },
        });
        if (res.status === 200) {
          //console.log("Invoice Nr. was created.");
          invoicedata.Payment.InvoiceNumber = "HO-" + res.data.data.Honey;
          //invoicedata.Payment.InvoiceNumber = "TESTBESTELLUNG";
          this.dbcreate(invoicedata);
        } else {
          this.isLoading = false;
          this.isProcessError = "true";
          if (invoicedata.Payment.Methode === "Kreditkarte") {
            this.ProcessError = "Die Rechnungsnummer für Bestellung "+invoicedata.OrderHashHoney+" ("+invoicedata.Purchase.ResultStripe.paymentIntent.id+" , "+invoicedata.Product.OrderQuantity+" Gläser) konnte nicht erstellt werden.";
          };
          if (invoicedata.Payment.Methode === "PayPal") {
            this.ProcessError = "Die Rechnungsnummer für Bestellung "+invoicedata.OrderHashHoney+" (PayPal: "+invoicedata.Purchase.AuthorizationPayPal.payerID+", "+invoicedata.Product.OrderQuantity+" Gläser) konnte nicht erstellt werden.";
          };
          //console.log("Could not create invoice number");
        }

        //console.log(JSON.stringify(res, null, 2));
      } catch (error) {
        this.isLoading = false;
        this.isProcessError = "true";
        if (invoicedata.Payment.Methode === "Kreditkarte") {
            this.ProcessError = "Die Rechnungsnummer für Bestellung "+invoicedata.OrderHashHoney+" ("+invoicedata.Purchase.TokenStripe.id+" , "+invoicedata.Product.OrderQuantity+" Gläser) konnte nicht erstellt werden.";
          };
          if (invoicedata.Payment.Methode === "PayPal") {
            this.ProcessError = "Die Rechnungsnummer für Bestellung "+invoicedata.OrderHashHoney+" (PayPal: "+invoicedata.Purchase.AuthorizationPayPal.payerID+", "+invoicedata.Product.OrderQuantity+" Gläser) konnte nicht erstellt werden.";
          };
        //console.log("ERROR:", error);
      }
    },

    async dbcreate(createdata) {
      try {
        const res = await axios.post(
          "/.netlify/functions/honeydbcreate",
          createdata,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        if (res.status === 200) {
          //console.log("DB-Data was added.");
          this.sendmail(createdata);
          this.updatearea(createdata);
        } else {
          this.isLoading = false;
          this.isProcessError = "true";
          if (createdata.Payment.Methode === "Kreditkarte") {
            this.ProcessError = "Die Daten für Bestellung "+createdata.OrderHashHoney+" ("+createdata.Purchase.TokenStripe.id+" , "+createdata.Product.OrderQuantity+" Gläser) konnten nicht in die Datenbank geschrieben werden.";
          };
          if (createdata.Payment.Methode === "PayPal") {
            this.ProcessError = "Die Daten für Bestellung "+createdata.OrderHashHoney+" (PayPal: "+createdata.Purchase.AuthorizationPayPal.payerID+", "+createdata.Product.OrderQuantity+" Gläser) konnten nicht in die Datenbank geschrieben werden.";
          };
          //console.log("DB-Data was not added.");
        }
        //console.log(JSON.stringify(res, null, 2));
      } catch (error) {
        this.isLoading = false;
        this.isProcessError = "true";
        if (createdata.Payment.Methode === "Kreditkarte") {
            this.ProcessError = "Die Daten für Bestellung "+createdata.OrderHashHoney+" ("+createdata.Purchase.TokenStripe.id+" , "+createdata.Product.OrderQuantity+" Gläser) konnten nicht in die Datenbank geschrieben werden.";
          };
          if (createdata.Payment.Methode === "PayPal") {
            this.ProcessError = "Die Daten für Bestellung "+createdata.OrderHashHoney+" (PayPal: "+createdata.Purchase.AuthorizationPayPal.payerID+", "+createdata.Product.OrderQuantity+" Gläser) konnten nicht in die Datenbank geschrieben werden.";
          };
        //console.log("ERROR:", error);
      }
    },

    async sendmail(maildata) {
      try {
        const res = await axios.post("/.netlify/functions/honeysendmail", maildata, {
          headers: { "Content-Type": "application/json" },
        });
        if (res.status === 200) {
          //console.log("Mail was send.");
          this.isLoading = false;
          this.$emit("thankYouPage", true);
        } else {
          this.isLoading = false;
          this.isProcessError = "true";
          this.ProcessError = "Die Bestellbestätigung für Bestellung "+maildata.OrderHashHoney+" / "+maildata.Payment.InvoiceNumber+" konnte nicht versendet werden.";
          //console.log("Mail was not send.");
        }
        //console.log(JSON.stringify(res, null, 2));
      } catch (error) {
        this.isLoading = false;
        this.isProcessError = "true";
        this.ProcessError = "Die Bestellbestätigung für Bestellung "+maildata.OrderHashHoney+" / "+maildata.Payment.InvoiceNumber+" konnte nicht versendet werden.";
        //console.log("ERROR:", error);
      }
    },

    async updatearea(areadata) {
      try {
        const res = await axios.post("/.netlify/functions/updatehoneystock", areadata, {
          headers: { "Content-Type": "application/json" },
        });
        if (res.status === 200) {
          //console.log("TotalArea was updated.");
        } else {
          //console.log("TotalArea was not updated.");
        }
        //console.log(JSON.stringify(res, null, 2));
      } catch (error) {
        //console.log("ERROR:", error);
      }
    },
  },
};
</script>

<style lang="scss">
.modalpadding {
  padding: 1.5rem 1rem;
  text-align: left !important;
}
.b-checkbox.checkbox input[type="checkbox"]:focus:checked + .check.is-info {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.priceborder {
  border-bottom: 2px solid $primary;
}
.totalborder {
  border-bottom: 4px solid $info;
}

.StripeElement {
  margin-top: 10px;
  width: 100%;
  padding-bottom: 0.625em;
  padding-left: 0.625em;
  padding-right: 0em;
  padding-top: 0.625em;
  border: 1px solid #ccc;
  border-radius: 4px;
  border-color: #dbdbdb;
  margin-bottom: .5rem;
}
.StripeElement--complete {
  border-color: $primary;
}

.StripeElement--invalid {
  border-color: $info;
}
</style>
